import { InheritanceStatus, QuestInterface } from "@swivl-mono/types";
import _ from "lodash";
import { useEffect, useState } from "react";
import { shallow } from "zustand/shallow";

import { PageLoadingView } from "../../App/Layout/Loading/LoadingView";
import { BrainsModel } from "../../Models/Brains/Brains.Model";
import { Member } from "../../Models/Member/Member.Current";
import { NavBar } from "../../Models/NavBar/NavBar.Model";
import { QuestsModel } from "../../Models/Quests/Quests.Model";
import Board from "./Board/Board";
import { WorkflowsNavHeaderBotName } from "./Components/WorkflowsNavHeaderBotName/WorkflowsNavHeaderBotName";
import { WorkflowsNavSearch, WorkflowsNavSearchInterface } from "./Components/WorkflowsNavSearch/WorkflowsNavSearch";
import { WorkflowsRouterAndBrainButtons } from "./Components/WorkflowsRouterAndBrainButtons/WorkflowsRouterAndBrainButtons";

export default function UserJourneysView() {
  const { workflows, loadingAllData } = QuestsModel.useState((s) => s, shallow);

  // const [searchQuery, setSearchQuery] = useState("");

  const [searchData, setSearchData] = useState<WorkflowsNavSearchInterface>({
    searchQuery: "",
    searchType: "quest",
    inheritanceFilter: "ALL",
    isSearching: true,
  });

  const searchUpdated = (newSearchData: WorkflowsNavSearchInterface) => {
    if (newSearchData.searchType === "node" && searchData.searchType !== "node") {
      QuestsModel.loadQuestsList(true, true);
    }
    setSearchData(newSearchData);
  };

  useEffect(() => {
    QuestsModel.loadQuestsList();
    BrainsModel.load(false);
  }, []);

  useEffect(() => {
    NavBar.set(
      <WorkflowsNavHeaderBotName org={Member.org!} />,
      <WorkflowsRouterAndBrainButtons />,
      <WorkflowsNavSearch data={searchData} isChild={Member.isInChildOrg} searchUpdated={searchUpdated} isLoading={loadingAllData} />,
      "Workflows",
    );
  }, [searchData, loadingAllData]);

  if (!workflows) {
    return <PageLoadingView />;
  }

  let filteredWorkflows = _.cloneDeep(workflows);
  let isFiltering = false;
  // if (Member.isInChildOrg && !Member.isSuperAdmin) {
  //   filteredWorkflows.forEach((workflow) => {
  //     workflow.quests = workflow.quests.filter((quest:QuestInterface) => {
  //       if (quest.inheritance === InheritanceStatus.IS_PARENT) { return false }

  //       return true;
  //     })
  //   })
  //   isFiltering = true;
  // }

  if (searchData.searchQuery.length > 0 || searchData.inheritanceFilter !== "ALL") {
    if (searchData.inheritanceFilter !== "ALL") {
      isFiltering = true;

      filteredWorkflows.forEach((workflow) => {
        workflow.quests = workflow.quests.filter((quest: QuestInterface) => {
          if (quest.inheritance === searchData.inheritanceFilter) {
            return true;
          }
        });
      });
    }

    if (searchData.searchQuery.length > 0) {
      isFiltering = true;
      const query = searchData.searchQuery.toLowerCase();
      if (searchData.searchType === "node") {
        filteredWorkflows.forEach((workflow) => {
          workflow.quests = workflow.quests.filter((quest) => {
            if (quest.data && JSON.stringify(quest.data)?.toLowerCase().indexOf(query) !== -1) {
              return true;
            }
          });
        });
      } else {
        filteredWorkflows.forEach((workflow) => {
          workflow.quests = workflow.quests.filter((quest) => {
            if (quest.name.toLowerCase().indexOf(query) !== -1) {
              return true;
            }
          });
        });
      }
    }
  }
  if (isFiltering) {
    filteredWorkflows = filteredWorkflows.filter((workflow) => workflow.quests?.length > 0);
  }

  return (
    <div style={{ overflow: "auto" }}>
      <Board isSearching={true} workflowJournys={filteredWorkflows} />
    </div>
  );

  // }

  // return <div style={{ overflow: "auto" }}>
  //   <Board
  //     isSearching={false}
  //     workflowJournys={workflows} />
  // </div>
}
